var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApartment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18079",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h4v5H0z",
    transform: "translate(4 23)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h3v4h-3z",
    transform: "translate(4 23)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18099",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h4v5H0z",
    transform: "translate(6 23)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h3v4h-3z",
    transform: "translate(6 23)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18102",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v4H0z",
    transform: "translate(4 13)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h5v3h-5z",
    transform: "translate(4 13)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18101",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v4H0z",
    transform: "translate(4 18)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h5v3h-5z",
    transform: "translate(4 18)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18103",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v4H0z",
    transform: "translate(4 8)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h5v3h-5z",
    transform: "translate(4 8)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18104",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h6v3H0z",
    transform: "translate(4 3)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h5v2h-5z",
    transform: "translate(4 3)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18083",
    transform: "translate(12 4)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h1v24H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 23,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18084",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h2v24H0z",
    transform: "translate(1 4)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h1v23h-1z",
    transform: "translate(1 4)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18085",
    transform: "translate(0 3)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18086",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h4v5H0z",
    transform: "translate(20 23)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h3v4h-3z",
    transform: "translate(20 23)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18100",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h4v5H0z",
    transform: "translate(23 23)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h3v4h-3z",
    transform: "translate(23 23)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18087",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v4H0z",
    transform: "translate(20 8)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v3h-6z",
    transform: "translate(20 8)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18088",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v4H0z",
    transform: "translate(20 18)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v3h-6z",
    transform: "translate(20 18)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18105",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v4H0z",
    transform: "translate(20 13)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v3h-6z",
    transform: "translate(20 13)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18089",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v3H0z",
    transform: "translate(20 3)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v2h-6z",
    transform: "translate(20 3)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18090",
    transform: "translate(28 4)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h1v24H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 23,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18091",
    transform: "translate(18 4)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h1v24H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 23,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18092",
    transform: "translate(17 3)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 1,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18093",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v4H0z",
    transform: "translate(12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v3h-6z",
    transform: "translate(12 13)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18094",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v4H0z",
    transform: "translate(12 8)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v3h-6z",
    transform: "translate(12 8)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18095",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h7v4H0z",
    transform: "translate(12 18)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h6v3h-6z",
    transform: "translate(12 18)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18096",
    transform: "translate(0 27)",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 1,
    rx: 0.5,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18097",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h7a1 1 0 0 1 1 1v3H0V1a1 1 0 0 1 1-1z",
    style: {
      stroke: "none"
    },
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 .5h7a.5.5 0 0 1 .5.5v2.5h-8V1A.5.5 0 0 1 1 .5z",
    style: {
      fill: "none"
    },
    transform: "translate(3)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 18098",
    style: {
      stroke: "gray",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0h7a1 1 0 0 1 1 1v3H0V1a1 1 0 0 1 1-1z",
    style: {
      stroke: "none"
    },
    transform: "translate(19)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 .5h7a.5.5 0 0 1 .5.5v2.5h-8V1A.5.5 0 0 1 1 .5z",
    style: {
      fill: "none"
    },
    transform: "translate(19)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/apartment.d67a854eb2f41dacb2df688fd078527b.svg";
export { ForwardRef as ReactComponent };